/**
 * PROPS
 *
 * bannerUrl => Banner image url | default https://image.femaledaily.com/dyn/1000/mxb2022/baner-mxb.jpg | string
 * marginTop => margin top compoenent | default 0px | string
 * marginBottom => margin bottom compoenent | default 0px | string
 */

import React from "react";
import Image from "next/image";
import PropTypes from "prop-types";

const BannerTicketDesktop = (props) => {

	const { bannerUrl, marginTop, marginBottom } = props;

	return (
		<>
			<div className="banner">
				<div className="image-container">
					<Image
						layout="fill"
						src={bannerUrl}
						objectFit="contain"
						objectPosition="bottom"
						alt="banner"
						quality={100}
						priority
					/>
				</div>
				{/* <Image
					className="banner__img"
					src={bannerUrl}
					layout="responsive"
					width="414px"
					height="77px"
					alt="banner"
					quality={100}
				/> */}
			</div>
			<style>
				{`
				.banner {
					margin: ${marginTop} 0 ${marginBottom} 0;
					padding: 0;
					text-align: center;
					background: none;
					position: relative;
					background-color: #000;
					width: 100vw;
					height: 20vw;
					display: block;
				}
				{/* .banner__img {
					margin: 0 auto 0 auto;
				} */}
			`}
			</style>
		</>
	);

};

BannerTicketDesktop.propTypes = {
	bannerUrl: PropTypes.string,
	marginTop: PropTypes.string,
	marginBottom: PropTypes.string,
};

BannerTicketDesktop.defaultProps = {
	bannerUrl:
		"https://image.femaledaily.com/xbeauty/2024/bxb-2024-1100x284.jpg",
	marginTop: "0px",
	marginBottom: "0px",
};

export default BannerTicketDesktop;
